//慧声辅助页面
<template>
  <el-row type="flex" justify="center" class="huisheng_assitant">
    <el-col v-show="!isShowVideo" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="huisheng_assitant_top">
      <!-- <img src="@/assets/img/huisheng_fuzu/fuzu_bg.png" /> -->
      <el-row type="flex" justify="center">
        <el-col :xs="24" :sm="24" :md="24" :lg="15" :xl="15" data-aos="fade-right" class="huisheng_assitant_top_text" :style="{'margin-left': isMobile ? '2em' : ''}">
        <div class="huisheng_assitant_top_text_1">
          <span>智能坐席辅助</span>
        </div>
        <div class="huisheng_assitant_top_text_2">
          <span>依靠AI，辅助客服人员，提升接待质量</span>
        </div>
        <!-- <el-button type="text" class="huisheng_assitant_top_text_btn" @click="PlayVideo()">查看演示视频></el-button> -->
        </el-col>
      </el-row>
    </el-col>
    <div class="showVideo" v-show="isShowVideo">
      <!-- <video controls ref="showVideo" @mousedown="videoClick()">
        <source src="@/assets/movie.ogg" type="video/ogg" />
      </video> -->
      <el-button type="primary" icon="el-icon-arrow-left" @click="exitVideo">返回</el-button>
    </div>

    <!-- <div class="huisheng_assitant_center">
      <el-row type="flex" justify="center">
        <el-col :xs="24" :sm="24" :md="24" :lg="15" :xl="15" style="margin:0 2em;">
          <div data-aos="fade-up" class="center">
            <img src="@/assets/img/huisheng_fuzu/fuzu_center.png" />
            <div class="center_right">
              <h4>辅助系统要解决的问题</h4>
              <p>
                <span></span>随着金融服务在多平台、多媒介的拓展,一方面客户对于金融产品的应用场景日益频繁,相应的客服咨询与协助需求也直线上升;但客户的耐心随着生活节奏的加快越来越少,人们厌恶等待、厌恶问题得不到及时的解决。
              </p>
              <p>
                <span></span>这一局面无疑给广大客服人员带来不小的挑战,企业也为提高服务质量而耗费大量时间和人力成本进行客服的管理和再培训,带来的效果却平平如常。
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-col class="huisheng_assitant_bottom" :xs="24" :sm="24" :md="24" :lg="15" :xl="15">
      <div data-aos="fade-up" class="bottom_title">
        <span>科技回归到本真,是给人们提供服务、解决问题。</span>
        <span>推出的辅助坐席系统恰恰是解决这一困境的有效工具</span>
      </div>
      <el-row type="flex" justify="center" class="bottom_center">
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" data-aos="flip-up" class="bottom_center_item" v-for="(item,index) in bottomData" :key="index">
          <img :src="item.imgUrl" />
          <div class="item_right">
            <h4>{{item.title}}</h4>
            <p>{{item.text}}</p>
          </div>
        </el-col>
      </el-row>
    </el-col> -->
  </el-row>
</template>

<script>
import ResizeEvent from "@/components/resizeEvent";

export default {
  name: "assitant",
  data() {
    return {
      // 坐席辅助数据
      // bottomData: [
      //   {
      //     imgUrl: require("@/assets/img/huisheng_fuzu/fuzu_bottom1.png"),
      //     title: "实时语音转文字",
      //     text:
      //       "客户与客服对话实时转成文字,便于坐席回顾、理解通话内容，提高服务质量和服务效率。"
      //   },
      //   {
      //     imgUrl: require("@/assets/img/huisheng_fuzu/fuzu_bottom2.png"),
      //     title: "导航动态提醒",
      //     text:
      //       "根据业务导航,依次询问关键点。快速灵活定位业务模块，便于快速回顾、查询相关信息"
      //   },
      //   {
      //     imgUrl: require("@/assets/img/huisheng_fuzu/fuzu_bottom3.png"),
      //     title: "实时话术推荐",
      //     text:
      //       "客户与针对客户提出的问题,智能辅助系统自动识别客户问题,提供相对应的答案。就算是新手客服,也能对着屏幕沉着冷静地回答客户的问题,为客户及时解决问题。"
      //   },
      //   {
      //     imgUrl: require("@/assets/img/huisheng_fuzu/fuzu_bottom4.png"),
      //     title: "实时质检,表达规范",
      //     text:
      //       "实时监测敏感词，语速、服务态度等质检项。一旦违规，系统弹屏提醒,保障服务态度，降低投诉风险。"
      //   },
      //   {
      //     imgUrl: require("@/assets/img/huisheng_fuzu/fuzu_bottom5.png"),
      //     title: "客户画像自动录入",
      //     text:
      //       "智能辅助专门解决传统客服低效率录入信息问题，在通话的过程中就实时将客户提及的个人信息录入到工单系统中,不用人工费心,也保证了数据的客观准确性。"
      //   }
      // ],
      isShowVideo: false,
      el_video: {}
    };
  },
  mixins:[ResizeEvent],
  methods: {
    // 播放演示视频
    PlayVideo() {
      // this.isShowVideo = true;
      // this.el_video.load();
    },
    videoClick() {
      console.log(this.$refs.showVideo.paused);
    },
    exitVideo() {
      this.isShowVideo = false;
    }
  },
  mounted() {
    this.el_video = this.$refs.showVideo;
  }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 1300px) {
  .huisheng_assitant>.huisheng_assitant_top {
    width: 1300px;
    height: 500px;
    background-size: 1300px 500px;
    background-position: center;
  }
}
@media only screen and (max-width: 1600px) and (min-width: 1300px) {
  .huisheng_assitant>.huisheng_assitant_top {
    width: 1600px;
    height: 600px;
    background-size: 1600px 60px;
    background-position: center;
  }
}
.huisheng_assitant {
  font-weight: 300;
  flex-flow: row wrap;
  .huisheng_assitant_top {
    height: 700px;
    width: 100%;
    background: url("../../assets/img/huisheng_fuzu/fuzu_bg.png") no-repeat
      center;
    color: #fff;
    border-top: 1px solid white;
    // img {
    //   position: absolute;
    //   z-index: -10;
    //   height: 700px;
    //   width: 100%;
    // }
    .huisheng_assitant_top_text {
      // width: 60rem;
      height: 20.3rem;
      margin: 10.45rem auto 0px;
      // margin-top: 209px;
      // margin-left: 361px;
      line-height: 4.5rem;
      .huisheng_assitant_top_text_1 {
        height: 2.85rem;
        font-size: 3rem;
        font-weight: lighter;
      }
      .huisheng_assitant_top_text_2 {
        height: 1.5rem;
        font-size: 1.2rem;
        margin-top: 4rem;
        line-height: 1.5rem;
        white-space: nowrap;
        font-weight: lighter;
      }
      .huisheng_assitant_top_text_btn {
        width: 20rem;
        height: 3.8rem;
        margin-top: 3.95rem;
        background: rgba(255, 255, 255, 1);
        font-size: 1.8rem;
        color: rgba(32, 102, 233, 1);
        border-radius: 0;
        font-weight: 300;
      }
    }
    @media only screen and (max-width: 997px){
      height: 300px;
      background-size: auto 300px;
      
    }
  }
  .showVideo {
    height: 35rem;
    width: 100%;
    // background-color: #5772fe;
    position: relative;
    video {
      width: 100%;
      height: 100%;
    }
    .el-button {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  .huisheng_assitant_center {
    width: 100%;
    // height: 35rem;
    background-color: #f7f8fc;
    border-top: 1px solid white;
    .center {
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      img {
        width: 28.95rem;
        height: 24.2rem;
        margin-top: 4.6rem;
      }
      .center_right {
        width: 23.5rem;
        // height: 17.5rem;
        margin: 10.15rem auto 8rem;
        h4 {
          font-size: 1.8rem;
        }
        p {
          font-size: 0.8rem;
          margin-top: 3rem;
          line-height: 1.5rem;
          span {
            width: 0.4rem;
            height: 0.4rem;
            display: inline-block;
            border-radius: 50%;
            margin-right: 0.5rem;
            background-color: #5772fe;
          }
        }
      }
    }
    @media only screen and (max-width: 997px){
      .center{
        img{
          height: 10rem;
          width: auto;
          align-self: center;
        }
        .center_right{
          margin: 5rem auto;
          p{
            font-size: 0.7rem;
            line-height: 2.5rem;
          }
        }
      }
    }
  }

  .huisheng_assitant_bottom {
    // height: 70.5rem;
    border-top: 1px solid white;
    margin: 0 2em;
    margin-bottom: 5rem;
    .bottom_title {
      width: 45rem;
      height: 6rem;
      margin: 6rem auto 0;
      font-size: 1.8rem;
      line-height: 3rem;
      display: flex;
      flex-direction: column;
      text-align: center;
      span {
        flex: 1;
      }
    }
    .bottom_center {
      // width: 60rem;
      // height: 48rem;
      margin: 4.35rem auto 0;
      // display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      align-content: space-between;

      .bottom_center_item {
        box-sizing: border-box;
        width: 27.5rem;
        margin-bottom: 2rem;
        min-height: 14rem;
        box-shadow: 0px 2px 20px 0px rgba(2, 2, 2, 0.2);
        padding: 1.8rem 0 0 1.8rem;

        img {
          width: 3.8rem;
          height: 3.8rem;
          vertical-align: top;
        }
        .item_right {
          display: inline-block;
          width: 17.2rem;
          margin-left: 1.7rem;
          h4 {
            font-size: 1.8rem;
            margin-bottom: 2.4rem;
          }
          p {
            font-size: 0.75rem;
            line-height: 1.5rem;
          }
        }
      }
      @media only screen and (max-width: 997px){
        justify-content: center!important;
        .bottom_center_item{
          width: 90%!important;
          .item_right{
            width: 70%;
            p{
              font-size: 0.7rem;
              line-height: 2.5rem;
              margin-bottom: 1rem;
            }
          }
        }
      }
    }
  }
}
</style>